import { Skeleton } from 'antd';
import type { FC } from 'react';

const WAYPOINT_COUNT = 4;

const WaypointSkeleton: FC = () => {
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <Skeleton.Avatar active size={30} />
      <div style={{ flex: 1 }}>
        <Skeleton.Input active size="small" style={{ width: 180, height: 16, marginBottom: 6 }} />
        <Skeleton.Input active size="small" style={{ width: 130, height: 16, marginBottom: 6 }} />
        <Skeleton.Input active size="small" style={{ width: 100, height: 14 }} />
      </div>
    </div>
  );
};

export const DriverDrawerBodySkeleton: FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '8px 0' }}>
      {Array.from({ length: WAYPOINT_COUNT }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
        <WaypointSkeleton key={i} />
      ))}
      <div style={{ marginTop: 4 }}>
        <Skeleton.Input active size="small" style={{ width: 200, height: 20, marginBottom: 8 }} />
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </div>
    </div>
  );
};
